<template>
  <div class="footer" @click="close">
    <!-- <img class="foo" src="@/assets/img/foo.png" /> -->
    <div class="foot-wrap">
      <div class="one">
        <img class="logo" src="@/assets/logo.png" alt />
      </div>
      <div class="fiv">
        <div class="common">
          <div class="first">关于我们</div>
          <div class="second">自听风·企业简介</div>
        </div>
      </div>
      <div class="two">
        <div class="common">
          <div class="first">自听风产品</div>
          <div class="second">社交场景化定制</div>
          <div class="second">社交场景化共创</div>
          <div class="second">社交场景化增值</div>
        </div>
      </div>
      <div class="three">
        <div class="title">合作伙伴（排名不分先后）</div>
        <div class="address">合作伙伴名称</div>
        <div class="address">合作伙伴名称</div>
        <div class="address">合作伙伴名称</div>
        <div class="address">合作伙伴名称</div>
      </div>
      <div class="four">
        <div class="title">联系我们</div>
        <div class="at">客服电话：</div>
        <div class="at">举报电话：</div>
        <div class="at">投诉信箱地址：</div>
      </div>
      <div class="six">
        <div class="title">扫码进入 自听风小程序</div>
        <img class="footim" src="@/assets/footer.png" />
      </div>
    </div>

    <div class="footer-copyright">
      <div class="footq">
        <!-- <a href="https://beian.miit.gov.cn/" class="open">粤ICP备2024357144号-1</a>
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAFQklEQVRYw+3Wa1BUdRjH8SOpMeg4WhZGpDIxiaaTeUFgWrxE4AVRQJGlRRAVIV1JkbgMgQLi5AVBQSVLSp0xlEAUKBEEFZCrCstll8UV2AV2YbmoGCrYv31+R95UL5pmmtamZ+bz6rz5nvOc/5zDcX9jGLs/iTxuyvIlWYkRFeTHA2HVRFtzfhthTG5KuH96/vUgNlC4mMgyw1NJit/aAXLKazYje9xtIMZ/OZz50gW+9hcNkvoLEemEPbnrSP47QYwxQ5Ifv54RqzcXwFFvSyjaOhfavN8F7Y5ZcC/HH9JOB4LNa9Zw5YA76OZV8vIGMdZtSp7cDrtOnOavYiQhTAiPwi1AMtIQaqyngsxpBtw2GAGDKfaQmpUAa6xc4Vfp4UtEdzAMycsT9JQ1Tyctl/2eEkuTlYysF/rCUNxMqDEzgTqzSXBnpgnIHCzgjvEEuD52DLBr3rA1MAaWmNtB582wdtIljZ9G9D+IPU6aTxIPBjHCcXvg3CEh9K2fDLWvjIH6D6fwTIyheuwEqLUyhzLOALq8pkN+bgRw3HY4FBsMzxojZxP9DequLjAlQwVrbpIjhyIY4UYGQ/buhdBqPxlk3Gion2IMDQIz3kJe/ZS34I7uHkmD7VSQVgYDNyIAwsNCgfXGXoOBPjP9DKrOCAogA2etGTmTHAMcFwFZye7wS5QlVHGjoEw4A2qPCUBZ6AzNcQ5Q/YYRdO+YB1U3dsDwypLio4FJ3ECryIzWz6Cm3NgTRHN8HiPF6eHAGSbAdh8feFZkB7krzaHE9h2o85sDsiAbkIsXQMN+e2CtGyF0kzdwXCgU5++D/ouLQFV4OEU/g2Q/iNuIPNaKkQflAWBqexxGjhLDVUcL6IwSQN3SGVChe6FJg9dckCx6D1QBliDZLIAxo7eA8eyv4KE0BJqTrHkZvnL9DJKn+Twmt0NsGGHZy2Dn3kQYfsQ53Hh4/r4RNGz8AIpdzKEuaAF0RC2E57MmQgE3ATjuM/CPiANW7AqSfQJQ5vk362eQKmd3JrmXsoSRocpNIMnbB9zbceDIWUPmuHFQNMkISqa9DpUvNK6YDpW2s8DfwBK48WFQnhMCgzUBoLy0BrRVe5P0NWjPLdKUsJiR1tR1wGp8IeZwMgx/SrgRvjxuAziNcwLvyathLOcJHLflhRDYGRYFrNET2rJ5yvPLoas0tOj/oL8UpC4JHyTSU+6MNCS4gvKoAB5WiKG+MAQSg0WwLXQ/ZJ3xhao0FxB5hYCbUwAEfhEF3Td8QP2dAOQnPwFlxgrolUVq9TPoaX+ZB2nLc2Gk6awj1MU78HZZwJMid2Byb550JQwVO0NfxlJgdz14vWKeRAiK6DlQF28PLZdcoLNcBIO92bb6GTQ8Q/13RURT6tlH2gvXMlITLYD6uI+gp2ozdF0VQXumM6ivCqGvahM8kPiDItkeGo8tB025GFQ3xFrSr06zI3/4yde7oN7m0sWk5eKWDqK5JWJQvAHac9ygq3Adr9gTNNc3QG85rzPfHe5/7wDtPwuhp/Zz6CjyhaZzwi6ivfetHdH/oP77+3PJQOsuRnqkQdCa4wWqyx6gyecpL64GTaEX7ycXUJz4GJp1B4O0X/Hg0Xp1tFV+8Ei1k6c5coHofxBrrzQinbKYo0SVJ+wn6iurGHlY5gY911aDJnMFaHXXiDp9GQyvtKfUA9QFTtBZ7gPdit0tpFd9OpwwFmlA9D/o9yNLDpxIKmI8PMnNSNtviCLVpYTITzrXEGWaq4qos0WgOPdpCenIF+eRrurjB4k0PXopYZG6gMg/D/gNBUxhAbSAmKMAAAAASUVORK5CYII="
          alt
          class="beian"
        />
        <span class="ww">粤公网安备xxx号</span>-->
        <span class="qq">
          版权所有 邯郸自听风科技有限公司 Copyright©2024-2024,All Rights
          Reserved.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  components: {},
  methods: {
    goToPage (path) {
      this.$router
        .push(path)
        .then(() => {
          window.scrollTo(0, 0)
        })
        .catch((err) => { })
    },
    goGuan (url) {
      window.location.href = url
    },
    close () {
      this.$emit("close")
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  // position: fixed;
  position: relative;
  width: 24rem;
  height: 7.25rem;
  left: 0;
  bottom: 0;
  // background: radial-gradient(
  //   circle at 100% 0%,
  //   #a37121 0%,
  //   rgba(30, 31, 33, 0) 100%
  // );
  background: #e4e7ea;
  // opacity: 0.8;
  // z-index: 299;
  // overflow: hidden;
  // margin-top: 0.875rem;

  .footq {
    position: absolute;
    bottom: 0;
    width: 24rem;
    height: 0.875rem;
    // margin-top: 3.4rem;
    background: rgba(163, 113, 33, 0);
    color: #fff;
    border-top: 0.0125rem solid #35383b;
  }

  .foot-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-between;

    .one {
      .logo {
        position: absolute;
        width: 2.23rem;
        height: 1.05rem;
        top: 0.75rem;
        left: 4.5rem;
      }
    }
    .fiv {
      display: flex;
      margin: 2.29rem 0 0 4.49rem;
      .common:not(:first-child) {
        margin-left: 1.5rem;
        cursor: pointer;
      }

      .first {
        font-weight: bold;
        font-size: 0.25rem;
        color: #333333;
        margin-bottom: 0.19rem;
        // cursor: pointer;
      }
      .second {
        font-weight: 400;
        font-size: 0.17rem;
        color: #333333;
        margin-bottom: 0.175rem;
        cursor: pointer;
      }
    }
    .two {
      display: flex;
      margin: 2.29rem 0 0 0.96rem;
      .common:not(:first-child) {
        margin-left: 1.5rem;
        cursor: pointer;
      }

      .first {
        font-weight: bold;
        font-size: 0.25rem;
        color: #333333;
        margin-bottom: 0.2rem;
        // cursor: pointer;
      }
      .second {
        font-weight: 400;
        font-size: 0.17rem;
        color: #333333;
        margin-bottom: 0.175rem;
        cursor: pointer;
      }
    }

    .three {
      margin: 2.29rem 0 0 1.14rem;
      .title {
        font-weight: bold;
        font-size: 0.25rem;
        color: #333333;
        margin-bottom: 0.2rem;
      }
      .address {
        font-weight: 400;
        font-size: 0.17rem;
        color: #333333;
        margin-top: 0.2rem;
        cursor: pointer;
      }
    }
    .four {
      margin: 2.29rem 0 0 1.01rem;
      .title {
        font-weight: bold;
        font-size: 0.25rem;
        color: #333333;
        margin-bottom: 0.2rem;
      }
      .at {
        font-weight: 400;
        font-size: 0.17rem;
        color: #333333;
        margin-top: 0.2rem;
        cursor: pointer;
      }
    }
    .six {
      margin: 1.09rem 0 0 2rem;
      .title {
        font-weight: bold;
        font-size: 0.25rem;
        color: #333333;
        margin-bottom: 0.2rem;
      }
    }
  }

  .footer-copyright {
    // height: 0.89rem;
    background: #e3593a;
    font-weight: 400;
    font-size: 0.17rem;
    // color: #fff;
    line-height: 0.89rem;
    text-align: center;

    :first-child span {
      // margin-left: 0.1rem;
    }
    .qq {
      margin-left: 0.3rem;
      color: #7f8287;
    }
    .ww {
      color: #7f8287;
    }
    .open {
      margin: 0 0.13rem;
      cursor: pointer;
      color: #7f8287;
    }

    .beian {
      margin: 0 0.06rem;
      width: 0.19rem;
      height: 0.19rem;
    }
  }
}
</style>
